import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Viewer, Worker, ProgressBar } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFileArrowDown,
} from "@fortawesome/free-solid-svg-icons";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

import INFO from "../data/user";
import SEO from "../data/seo";
import pdf from "../assets/2025Resume_MengyunXie_SoftwareEngineer.pdf";

import "./styles/resume.css";

const Resume = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "resume");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Resume | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.descriptions} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="resume" />
				<div className="content-wrapper">
					<div className="resume-container">
						<div className="title resume-title">
							{INFO.resume.title}
						</div>

						<div className="subtitle resume-subtitle">
							{INFO.resume.descriptions}
						</div>

						<div className="resume-file-container">
							<div className="resume-file-btn">
								<a href={pdf}  target="_blank" className="resume-file-btn-link" rel="noreferrer">
										<FontAwesomeIcon
											icon={faFileArrowDown}
											className="resume-icon"
										/>DownLoad
								</a>
							</div>
							<div className="resume-file">
								<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
									<Viewer 
										fileUrl={pdf} 
										renderLoader={(percentages) => (
											<div style={{ width: '240px' }}>
												<ProgressBar progress={Math.round(percentages)} />
											</div>
										)}
									
									/>
								</Worker>
							</div>
							<div className="resume-file-btn">
							<a href={pdf}  target="_blank" className="resume-file-btn-link" rel="noreferrer">
									<FontAwesomeIcon
										icon={faFileArrowDown}
										className="resume-icon"
									/>DownLoad
							</a>
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Resume;
